import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  label: {
    fontSize: 15,
    fontWeight: 'normal',
    letterSpacing: 'normal',
    color: '#3e424e',
  },
}));
